<template>
    <Toast position="bottom-right"/>
    <div class='tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center md:tw-justify-start nuevo-turno'>
        <Card class='animate tw-w-96 md:tw-ml-3 tw-p-4'>
            <template #title>
                <span>Nueva Cita</span>
            </template>
            <template #content>
                <div class='tw-w-full tw-flex tw-flex-col tw-space-y-4'>
                    
                    <!-- Especialidad -->
                    <Dropdown @change='handleChangeEspecialidad' class='tw-w-full' showClear v-model="especialidad" :options="especialidadesList" optionLabel="descripcion" placeholder="Especialidad" :filter="!isIOS" filterPlaceholder="Buscar.."/>
                    
                    <!-- Medico -->
                    <Dropdown class='tw-w-full' v-model="medico" :options="medicosList" optionLabel="nombre" placeholder="Profesional" :filter="!isIOS" filterPlaceholder="Buscar.."/>
                    
                    <!-- Sucursal -->
                    <Dropdown class='tw-w-full' v-model="sucursal" :options="sucursalesList" optionLabel="direccion" placeholder="Sucursal" :filter="!isIOS" filterPlaceholder="Buscar.."/>
                    

                    <div class="text-left flex flex-col">
                        <Checkbox id='videoConsulta' v-model="filtrarVideoConsulta" :binary="true"/>
                        <label for="videoConsulta" class="ml-2 cursor-pointer">Video consulta</label>
                    </div> 
                    <div class="text-left flex flex-col">
                        <Checkbox id='coberturaPrivada' v-model="isCoberturaPrivada" :binary="true"/>
                        <label for="coberturaPrivada" class="ml-2 cursor-pointer">Cita Privada</label>
                    </div>  

                    <!-- Toggle avanzadas -->                    
                    <div class='tw-w-full tw-flex tw-justify-end tw-items-center'>
                        <Button class='p-button-link ' label='Avanzada' @click='avanzadosToggle = !avanzadosToggle' :icon="`pi ${avanzadosToggle ? 'pi-minus' : 'pi-plus'}`" iconPos="right" />
                    </div>                                      

                    <!-- Avanzados -->
                    <div class='tw-w-full  tw-flex tw-flex-col tw-space-y-4 tw-transition-all' :class='{"tw-h-0 tw-overflow-hidden":!avanzadosToggle, "tw-h-36 tw-overflow-hidden ":avanzadosToggle}'>
                        <!-- Fecha -->
                        <Calendar class='tw-w-full' v-model="fecha" selectionMode="range"  :yearNavigator="true" yearRange="2000:2030" :monthNavigator='true'></Calendar>
                    
                        <!-- Horas -->
                        
                        
                        <!-- Dias -->
                        <div class='tw-flex! tw-justify-between! tw-items-center! tw-pt-2! tw-text-center'>
                            <div class='p-field-checkbox'>
                                <Checkbox class='tw-hidden!' id='lunes' value='Lunes' v-model="DiasSeleccionados" />
                                <label :class='{active:DiasSeleccionados.some(dia => dia === "Lunes")}' for="lunes" class='boton-dia tw-py-1! tw-px-2! tw-cursor-pointer tw-select-none'>Lu</label>
                            </div>
                            <div class='p-field-checkbox '>
                                <Checkbox class='tw-hidden!' id='martes' value='Martes' v-model="DiasSeleccionados" />
                                <label :class='{active:DiasSeleccionados.some(dia => dia === "Martes")}' for="martes" class='boton-dia tw-py-1! tw-px-2! tw-cursor-pointer tw-select-none'>Ma</label>
                            </div>
                            <div class='p-field-checkbox '>
                                <Checkbox class='tw-hidden!' id='miercoles' value='Miércoles' v-model="DiasSeleccionados" />
                                <label :class='{active:DiasSeleccionados.some(dia => dia === "Miércoles")}' for="miercoles" class='boton-dia tw-py-1! tw-px-2! tw-cursor-pointer tw-select-none '>Mi</label>
                            </div>
                            <div class='p-field-checkbox '>
                                <Checkbox class='tw-hidden!' id='jueves' value='Jueves' v-model="DiasSeleccionados" />
                                <label :class='{active:DiasSeleccionados.some(dia => dia === "Jueves")}' for="jueves" class='boton-dia tw-py-1! tw-px-2! tw-cursor-pointer tw-select-none'>Ju</label>
                            </div>
                            <div class='p-field-checkbox '>
                                <Checkbox class='tw-hidden!' id='viernes' value='Viernes' v-model="DiasSeleccionados" />
                                <label :class='{active:DiasSeleccionados.some(dia => dia === "Viernes")}' for="viernes" class='boton-dia tw-py-1! tw-px-2! tw-cursor-pointer tw-select-none'>Vi</label>
                            </div>
                            <div class='p-field-checkbox '>
                                <Checkbox class='tw-hidden!' id='sabado' value='Sábado' v-model="DiasSeleccionados" />
                                <label :class='{active:DiasSeleccionados.some(dia => dia === "Sábado")}' for="sabado" class='boton-dia tw-py-1! tw-px-2! tw-cursor-pointer tw-select-none'>Sa</label>
                            </div>
                            <div class='p-field-checkbox '>
                                <Checkbox class='tw-hidden!' id='domingo' value='Domingo' v-model="DiasSeleccionados" />
                                <label :class='{active:DiasSeleccionados.some(dia => dia === "Domingo")}' for="domingo" class='boton-dia tw-py-1! tw-px-2! tw-cursor-pointer tw-select-none'>Do</label>
                            </div>
                        </div>
                    </div>
                    
                    <Button :loading='isLoadSugerencias' :disabled='!especialidad || !medico || (!coberturaValida && !coberturaParticular)' label='Consultar Citas Disponibles' class='tw-w-full' @click="handleConsultarTurnos"></Button>
                </div>
                
            </template>
        </Card>
        
        <Dialog appendTo="self" position="right" class='lg:tw-mr-20!' header="Citas Disponibles" :style="{width: '50vw',}" :breakpoints="{'960px': '75vw', '640px': '100vw', '425px' : '100vw'}" v-model:visible="consultarTurnosForm">
        
            
            <DataTable class='table-turnos-disponibles' :value="turnosDisponiblesList" selectionMode="single" v-model:selection="turnoSeleccionado" responsiveLayout="stack" scrollHeight="50vh">
                <template #empty>
                    No se encontraron datos.
                </template>
                <Column  field="fecha"  class='tw-w-32'  header="Fecha"></Column>
                <Column field="hora" class='tw-w-12' header="Hora"></Column>
                <Column field="profesional" header="Profesional"></Column>
                <Column field="especialidad"  header="Especialidad"></Column>
                <Column field="sucursal"  header="Sucursal"></Column>
                

            </DataTable>
        
            <template #footer> 
                <hr class='tw-mt-2'>
                <div class='tw-pt-2'>
                    <Button :disabled='!turnoSeleccionado' type="button" class='p-button-primary ' :class='turnoSeleccionado ? "" : "p-button-outlined"' :loading='isLoadTurnosCreate'  @click='handleConfirmarSeleccion'>Confirmar</Button>
                    <Button label='Salir' class='p-button-primary p-button-outlined tw-px-8' @click="handleCancelarSeleccion"></Button>
                </div>
            </template>
        </Dialog>

        <Dialog :modal='true' :closable="false" appendTo="self" header="Esperando Pago" v-model:visible="isPagoVisible">
            <div class="tw-w-full tw-flex tw-items-center tw-justify-center tw-pt-8">
                <div class="tw-w-20 tw-rounded-full" style="aspect-ratio:1/1; border:2px solid lch(from var(--primary-color) l c h); border-left-color:lightgray;animation:spin 1s ease-in-out infinite;"></div>
            </div>
            <template #footer> 
                <hr class='tw-mt-2'>
                <div class='tw-pt-2'>
                    <Button :text="true" label='Cancelar' class='p-button-text tw-px-8' @click="handleCancelarPago"></Button>
                    <Button link label='Reintentar Pago' type="button" class='p-button-primary ' @click="handleRetryPago" icon="pi pi-external-link" iconPos="right"></Button>
                </div>
            </template>
        </Dialog>
        <Dialog :closable="false" :modal="true" appendTo="self" header="Cita Pendiente" v-model:visible="showConfirmTurnoPendiente">
            <div class="tw-w-full tw-flex tw-items-center tw-justify-center tw-pt-8">
                <span>{{ textTurnoPendiente }}</span>
            </div>
            <template #footer> 
                <hr class='tw-mt-2'>
                <div class='tw-pt-2'>
                    <Button :text="true" label='Cancelar' class='p-button-text tw-px-8' @click="handleCancelarPago"></Button>
                    <Button link label='Abonar' type="button" class='p-button-primary ' @click="handleConfirmTemporal" icon="pi pi-external-link" iconPos="right"></Button>
                </div>
            </template>
        </Dialog>
    </div>
    <InvoiceEmailDialog
        v-model="showInvoiceDialog"
        :email="invoiceDialogEmail"
        :idFactura="invoiceDialogFacturaId"
    />
</template>

<script lang='ts'>
import { defineComponent, ref, onBeforeMount, nextTick, computed, onUnmounted, watch } from "vue";
import InvoiceEmailDialog from '@/components/InvoiceEmailDialog.vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';

import { useToast } from "primevue/usetoast";
import { useConfirm } from "primevue/useconfirm";
import axios from '@/plugins/axios';
import { AxiosError } from "axios";

//Table
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';


import moment from 'moment';
import { TipoTurno } from '@/schemas/TipoTurno'
import { toIntlNumberFormat } from '@/utils'

const encodeURIComponente = (objeto:any) => {
    return encodeURIComponent(JSON.stringify(objeto))
}

enum RESTRICCIONES_ESPECIALIDADES {
    'NO_ATENDER' = 2,
    'SOLO_ATENDER' = 1
}


export default defineComponent({
    components:{
        DataTable,
        Column,
        InvoiceEmailDialog,
    },
    setup: () => {
        const router = useRouter();
        const route = useRoute();
        const store = useStore()
        const dialog = useConfirm();
        const coberturaValida = ref(false);
        const isCoberturaPrivada = ref(false);

        const isLoadSugerencias = ref(false);
        const isLoadTurnosCreate = ref(false);

        const paginaActual = ref(0);
        const elemento = ref()

        const toast = useToast();

        const avanzadosToggle = ref(false);
        const fecha = ref([new Date(moment().toISOString(true)),new Date(moment().add(2, 'months').calendar())]);
        const horaDesde = ref(new Date(new Date().setHours(0,0,0,0)))
        const horaHasta = ref(new Date(new Date().setHours(23,59,0,0)))

        const turnosDisponiblesList = ref([])
        const turnoSeleccionado = ref();
        
        const especialidadesList = ref([{}])
        const sucursalesList = ref([{}])
        const medicosList = ref([{}])
        
        const especialidad = ref(null);
        const medico = ref();
        const sucursal = ref();
        
        const DiasSeleccionados = ref(["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"]);

        
        const consultarTurnosForm = ref(false);

        const filtrarVideoConsulta = ref(false)
        const tiposTurnosDisponiblesList = ref<TipoTurno[] | undefined>()
        const coberturaParticular = ref<any>(null)
        const interval = ref<any>(null)
        const linkPago = ref<any>(null)
        const turnoTemp = ref<any>(null)
        const showConfirmTurnoPendiente = ref(false)
        const showInvoiceDialog = ref(false)
        const invoiceDialogEmail = ref('')
        const invoiceDialogFacturaId = ref<number|null>(null)
        const pendingTurnoNav = ref<any>(null)

        watch(showInvoiceDialog, (val) => {
            if (!val && pendingTurnoNav.value) {
                const turno = pendingTurnoNav.value
                pendingTurnoNav.value = null
                router.push({path:'mis-turnos', query:{q:turno.id}, params:route.params})
            }
        })
        const coberturaRequierePago = ref(false)
        const eventoDeScroll = (e:any) => {
            const { target:{scrollTop, offsetHeight, scrollHeight} } = e;
                    
            if(scrollTop + offsetHeight >= scrollHeight){
                obtenerTurnosDisponibles();
            }
        }


        const scrollBottom = () => {
            
            elemento.value?.removeEventListener('scroll',eventoDeScroll);

            elemento.value = document.querySelector('.p-dialog-content')
            
            elemento.value?.addEventListener('scroll',eventoDeScroll)

        }

        const handleConsultarTurnos = async () => {
            const paciente = store.state.pacienteLogueado
            
            if(!paciente.celular){
                dialog.require({
                    icon: 'pi pi-exclamation-triangle',
                    header:'Advertencia!',
                    message:'Para continuar debe ingresar un número telefonico de contacto.',
                    acceptLabel:'Continuar',
                    rejectLabel:'Cancelar',
                    accept:() => {
                        router.push({path:'mis-datos', query:{q:'telefono'}, params:route.params});
                    }
                })
                return;
            }

            if(!paciente.email){
                dialog.require({
                    icon: 'pi pi-exclamation-triangle',
                    header:'Advertencia!',
                    message:'Para continuar debe actualizar el email de contacto.',
                    acceptLabel:'Continuar',
                    rejectLabel:'Cancelar',
                    accept:() => {
                        router.push({path:'mis-datos',query:{q:'email'}, params:route.params});
                    },
                    reject:() => consultarTurnos()
                })
                return;
            }

            consultarTurnos();

            
        }

        const consultarTurnos = async () => {
            try {
                paginaActual.value = 0;
            
                if(isCoberturaPrivada.value){
                    const resp = await verificarPrivado();
                    if(!resp)return;
                }

                await obtenerTurnosDisponibles()
                
                
                consultarTurnosForm.value = true
                
                elemento.value?.scroll({top:0});

                await nextTick();

                

                scrollBottom()
                
            } catch (error) {
                console.log(error);
            }
        }


        const handleConfirmar = async () =>{
            const fecha = turnoSeleccionado.value.fecha;
            const hora = turnoSeleccionado.value.hora;
            const profesional = turnoSeleccionado.value.profesional;
            
            try {
               
                
                dialog.require({
                    message:`se agendara un cita con fecha ${fecha} a la hora ${hora} con ${profesional}.`,
                    header:'Confirmar Cita',
                    icon: 'pi pi-exclamation-triangle',
                    accept: handleConfirmarSeleccion,
                })



                
            } catch (error) {
                console.log(error);
            }



            
        }

        const verificarLimite = async () =>{
            try {
                const limite = store.state.configuracionPortal.limiteTurnos;
                
                 const filters ={
                    idcliente:store.state.configuracionPortal.idcliente,
                    idpaciente:store.state.pacienteLogueado.id,
                    fecha:{ '>=':moment()},
                }

                const { data } = await axios.get(`turnos?filters=${encodeURIComponente(filters)}`)

                const filtrados = data.turnos.filter((turno:any )=> {
                    if(turno.usuario.nombre !== 'PORTAL')return false;
                    
                    if(turno.fecha === moment().format('YYYY-MM-DD')){
                        return turno.hora >= moment().format('HH:mm:ss');
                    }

                    return true;



                })

                console.log(filtrados);

                if(filtrados.length >= limite){
                    toast.add({
                        severity:'error',
                        summary:'Limite de cita',
                        detail:'Ya no puede agendar mas citas',
                        life:3000
                    })
                    return false;
                }

                return true;
                
            } catch (error) {

                console.log(error);

                return false;


                
            }
        }

        const verificarDisponibilidad = async () =>{
            try {
                const fecha = turnoSeleccionado.value.fecha;
                const especialidad = turnoSeleccionado.value.idmedicoespecialidad;
                const filters = {
                    fecha:moment(fecha, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                    idmedicosespecialidad:especialidad,
                }


                const { data } = await axios.get(`turnos?filters=${encodeURIComponente(filters)}`)

                const turnos = data.turnos.filter((turno:any) => turno.paciente.id === store.state.pacienteLogueado.id)

                if(turnos.length > 0){
                    toast.add({
                        severity:'error',
                        summary:'Error',
                        detail:'Ya posee una cita en esa fecha para esa especialidad.',
                        life:3000
                    })
                    return false;
                }
               
                return true;
            } catch (error) {
                console.log(error)
                toast.add({
                    severity:'error',
                    summary:'Error',
                    detail:'Error al agregar la nueva cita.',
                    life:3000
                })
                return false;
            }
        }

        const getHorarioCita = (especialidad:any, cita:any) => {
            const { dia, hora , fecha } = cita
            const horario = especialidad.medicoHorarios.find(
                (horario:any) => horario.dia === dia 
                    && moment(hora, 'HH:mm').isBetween(moment(horario.horadesde, 'HH:mm'), moment(horario.horahasta, 'HH:mm'), 'minutes', '[]') 
                    && moment(fecha,'DD/MM/YYYY').isBetween(moment(horario.fechavigdes, 'YYYY-MM-DD'), moment(horario.fechavighas, 'YYYY-MM-DD'), 'days', '[]')
            )
            return horario
        }

        const getCitaFormated = ({data, cliente, idpaciente, idcobertura, idplancobertura, carnet, v_o,idcliente}:any) => ({
                    sobreturno: false,
                    hora: moment(data?.hora,'HH:mm').format('HH:mm:ss'),
                    fecha: moment(data?.fecha,'DD/MM/YYYY'),
                    presente: false,
                    idmedicosespecialidad: data?.idmedicoespecialidad,
                    idusuario: cliente.usuarios[0].id,
                    idcliente,
                    idpaciente,
                    idcobertura,
                    idplancobertura,
                    carnet,
                    v_o,
                    fechaasignacion: moment(),
                    horaasignacion: moment().format('HH:mm:ss'),
                    idtipoturno: idTipoTurnoSeleccionado.value,
        })

        const handleConfirmarSeleccion = async () => {
            const data = turnoSeleccionado.value
            const tipoVirtual = tiposTurnosDisponiblesList.value?.find( tipo => tipo.virtual === true)?.id
            const isVirtual = data.tipoturno.includes(tipoVirtual)
            const medicoEsp = (especialidad.value as any)?.medicoEspecialidads?.find((medEsp:any) => medEsp.id === data.idmedicoespecialidad);
            const horario = getHorarioCita(medicoEsp, data)
            if(!(await verificarDisponibilidad()))return;
            const profesionalRequiereCobro = store.getters.profesionalRequiereCobro(medicoEsp?.idespecialidad, medicoEsp?.id);
            const requiereCobro = coberturaRequierePago.value || profesionalRequiereCobro;

            isLoadTurnosCreate.value = true;

            try{
                let { carnet, id, v_o,idplancobertura,idcobertura } = store.state.pacienteLogueado;
                const {idcliente,cliente} = store.state.configuracionPortal

                if(!(await verificarLimite())) return;

                if(isCoberturaPrivada.value && coberturaParticular.value) {
                    idcobertura = coberturaParticular.value.id;
                    idplancobertura = coberturaParticular.value.planCoberturas?.[0]?.id;
                    carnet = '';
                    v_o = coberturaParticular.value.planCoberturas?.[0]?.v_o === 'A' ? 'NG' : coberturaParticular.value.planCoberturas?.[0]?.v_o
                }

                const cita = getCitaFormated({
                    data,
                    cliente,
                    idpaciente:id,
                    idcobertura,
                    idplancobertura,
                    carnet,
                    v_o,
                    idcliente
                })



                if((isVirtual || requiereCobro) && horario?.idprestacion){
                    await createCitaVirtualPaga({...cita, idprestacion:horario.idprestacion, verifyPortalUser: true})
                    return;
                }


                
                await createCita(cita)

                
                
            }catch(err){
                const { response } = err as AxiosError;
                const errMsg = response?.data?.message || 'Se produjo un error al crear la cita.'
                toast.add({severity:'error',summary:'Error',detail:errMsg,life:1500})
               
            }finally{
                isLoadTurnosCreate.value = false;
                turnoSeleccionado.value = undefined;
            }

            

        }


        const createCita = async (cita:any) => {
            const result = await axios.post('turnos',cita)

            notifyCita(result)
            
        }


        const notifyCita = async (result:any) => {
            try {
                toast.add({severity:'success',summary:'Exito',detail:'Cita agendada exitosamente.',life:1500})
                consultarTurnosForm.value = false;
                router.push({path:'mis-turnos', query:{q:result.data.id}, params:route.params});
                enviarMail(result.data);
            } catch (error) {
                console.log(error);
            }
        }

        const createCitaVirtualPaga = async (data:any) =>{
            try {
                const { paymentInfo } = await getPaymentInfo(data);
                if(paymentInfo.amount <= 0){
                    await createCita(data)
                    return;
                }

                if(!(await awaitPagoConfirmation(paymentInfo.amount)))return;

                const link = await getPaymentLink({
                    data,
                    amount:paymentInfo.amount,
                    descripcion:paymentInfo.descripcion,
                })

                const response = await awaitPago(link.mercadoPagoData)

                if(!response){
                    toast.add({severity:'error',summary:'Error',detail:'El pago fue rechazado.',life:1500})
                    return;
                }

                await getCitaCreada(link.mercadoPagoData.globalreference);

            } catch (error:any) {
                console.log(error)
                toast.add({severity:'error',summary:'Atencion',detail:error.response?.data?.message || error.message || "Huvo un problema al crear la cita.",life:1500})
            }
        }

        const getCitaCreada = async (globalreference:string, retries = 3): Promise<void> => {
            try {
                const {data:{rows:[turno]}} = await axios.get(`/turnos/get-all`, {
                    params:{
                        filters:JSON.stringify({
                            'metadata.mercadoPagoData.globalreference':globalreference
                        }),
                        includes:JSON.stringify([
                            {model:'medicoEspecialidad', include:[{model:'medico'},{model:'sucursal'},{model:'servicioEspecialidad'}]},
                        ]),
                        withPaymentInfo:true,
                    },
                })
                console.log(turno);

                if (!turno && retries > 0) {
                    await new Promise(r => setTimeout(r, 2000))
                    return getCitaCreada(globalreference, retries - 1)
                }

                const factura = turno?.factura
                if (factura?.afip && factura?.letraComprobante === 'B') {
                    toast.add({severity:'success',summary:'Exito',detail:'Cita agendada exitosamente.',life:1500})
                    consultarTurnosForm.value = false
                    invoiceDialogFacturaId.value = factura.id
                    invoiceDialogEmail.value = store.state.pacienteLogueado?.email || ''
                    pendingTurnoNav.value = turno
                    showInvoiceDialog.value = true
                } else {
                    notifyCita({data:turno})
                }
            } catch (error) {
                console.log(error);
            }
        }

        const getPaymentInfo = async (data:any) => {
            try {
                const { data:paymentInfo } = await axios.post('/turnos/get-new-payment-info',data)
                return paymentInfo;
            } catch (error) {
                console.log(error);
                throw error;
            }
        }

        const awaitPago = async (link:any) => {
            window.open(link.link, '_blank');
            linkPago.value = link;
            return new Promise((resolve, reject) => {
                interval.value = setInterval(async () => {
                    try {
                        const { data } = await axios.get(`/turnos/verify-payment/${link.globalreference}`)
                        if(data.status === 'approved' || data.status === 'rejected'){
                            linkPago.value = null;
                            clearInterval(interval.value)
                            resolve(data.status === 'approved')
                            return;
                        }
                    } catch (error) {
                        reject(error)
                    }
                }, 5000)
            })
        }

        const awaitPagoConfirmation = async (amount:number) => {
            return new Promise((resolve) => {
                dialog.require({
                    icon: 'pi pi-exclamation-triangle',
                    header:'Advertencia',
                    message:`Para continuar debe abonar la cita ${toIntlNumberFormat(amount)}. ¿Desea continuar?`,
                    acceptLabel:'Continuar',
                    rejectLabel:'Cancelar',
                    accept:() => {
                        resolve(true)
                    },
                    reject:() => {
                        resolve(false)
                    }
                })
            })
        }


        const getPaymentLink = async (data:any) => {
            try {
                const { data:link } = await axios.post('/turnos/generate-payment-link',data)
                return link;
            } catch (error) {
                console.log(error);
                throw error;
            }
        }

        const verificarPrivado = () => {
            return new Promise((resolve) => {
                dialog.require({
                        icon: 'pi pi-exclamation-triangle',
                        header:'Advertencia!',
                        message:'La cita de atención privada podría incluir un costo, y se le informará con antelación. ¿Desea continuar?',
                        acceptLabel:'Continuar',
                        rejectLabel:'Cancelar',
                        accept:() => {
                            resolve(true)
                        },
                        reject:() => {
                            resolve(false)
                        }
                    })
            })
        }

        const handleCancelarSeleccion = () => {
            turnoSeleccionado.value = null;
            consultarTurnosForm.value = false;
        }

        const handleChangeEspecialidad = (evt:{value:any , originalEvent:Event}) =>{
            obtenerMedicos(evt.value || undefined);
        }   


        const obtenerMedicos = async (Especialidad?:any) =>{
            try {
                
                const EspecialidadFiltrada = Especialidad.medicoEspecialidads; 
                
                const medicos = EspecialidadFiltrada
                .filter((medEsp:any)=> medEsp.medico.activoturnos === 'true')
                .map((medicoEsp:any)=>{
                    return {
                        ...medicoEsp.medico,
                        sucursal:{...medicoEsp.sucursal},
                    }
                })
                
               
                if(Especialidad){
                    sucursalesList.value = [{direccion:'Sucursal: Todas'}];
                    obtenerSucursales(medicos);
                }

                const medicosSinDuplicidad:any = [
                    ...medicos.reduce((acc:any,medico:any)=>{
                        if(!acc.some((med:any)=> med.id === medico.id)){
                            acc.push(medico);
                        }
                        return acc;
                    },[]).sort((medA : any, medB : any) => medA.nombre > medB.nombre ? 1 : -1)
                ];

                medicosList.value = [{nombre:'Profesional: Todos'},...medicosSinDuplicidad];
                
                medico.value = medicosList.value[0]
            } catch (error) {
                console.log(error);
            }
        }

        const obtenerEspecialidades = async () => {
            try {
                const especialidadesPermitidas = store.state.configuracionPortal.parametros.especialidades.top;
                const medicosPermitidos = store.state.configuracionPortal.parametros.especialidades.children;

                const filters = JSON.stringify({
                    tipo:'E',
                    orarr:[
                        {id:{in:[...especialidadesPermitidas]}},
                        {'$medicoEspecialidads.id$':{in:[...medicosPermitidos]}}
                    ]
                })
                const includes = JSON.stringify([
                    {
                        required:true,
                        model:'medicoEspecialidad',
                        include:[
                            {model:'medicoRestriccion'},
                            {model:'medico', required:true},
                            {model:'sucursal'},
                            {model:'medicoHorario'}
                        ]
                    }
                ]);
                const result = await axios.post(`especialidades-servicios/get-all`,{
                    filters,
                    includes
                });     
                 
                const esp = [...result.data.servEsp];
                
                
                esp.length > 0 
                    ? especialidadesList.value = [...esp].sort((espA, espB) => espA.descripcion > espB.descripcion ? 1 : -1) 
                    : especialidadesList.value = [];
                

                


                
            } catch (error) {
                console.log(error)
            }
        }

        const obtenerSucursales = (medicos:any) => {
            const sucursales = [...medicos.map((med:any)=> med.sucursal)];
            const hashSucursales:number[] = [];

            sucursales.forEach((suc:any) => {
                if(!hashSucursales.includes(suc.id)){
                    hashSucursales.push(suc.id);
                    sucursalesList.value.push({...suc, direccion:`${suc.sucursal || ''} - ${suc.direccion || ''}`});
                }
            });

            sucursal.value = sucursalesList.value[0];

            sucursalesList.value.sort((sucA : any, sucB : any) => sucA.direccion.includes('Todas') ? -1 : sucA.direccion > sucB.direccion ? -1 : 1 )
        }

        const getEdadPaciente = (fechaNacimiento:string) => {
            return moment().diff(moment(fechaNacimiento, 'YYYY-MM-DD'), 'years')
        }

        const obtenerTurnosDisponibles = async() =>{
            isLoadSugerencias.value = true;
            let { idplancobertura,idcobertura,fechanacimiento, sexo } = store.state.pacienteLogueado;
            const especialidadSelected = especialidad.value ? getObjectProps(especialidad.value, ['id']) : undefined

            if(isCoberturaPrivada.value && coberturaParticular.value){
                idcobertura = coberturaParticular.value.id;
                idplancobertura = coberturaParticular.value.planCoberturas?.[0]?.id;
            }

            const query = {
                origen: 'portal',
                especialidad:especialidadSelected,
                fechas:fecha.value,
                medico: medico.value?.id ? [medico.value.id] : [...medicosList.value.map((med:any)=>med.id)],
                dias:DiasSeleccionados.value,
                sucursal:sucursal.value?.id ? sucursal.value : null,
                pagina:paginaActual.value,
                checkRestrictions: true,
                idplancobertura,
                idcobertura,
                sexoPaciente:sexo,
                edadPaciente:getEdadPaciente(fechanacimiento),
                ...(filtrarVideoConsulta.value ? {turnoVirtual: turnosVirtuales.value} 
                    : {turnoPresencial: [idTipoTurnoSeleccionado.value]}
                )
            }
            
           try{

                if(turnoTemp.value){
                    isLoadSugerencias.value = false;
                    showConfirmTurnoPendiente.value = true;
                    return;
                }

                if(!coberturaValida.value && (!coberturaParticular.value || !isCoberturaPrivada.value)){
                    turnosDisponiblesList.value = []
                    return 
                }
                
                const result = await axios.get(`turnos-sugerir?query=${encodeURIComponente(query)}`)
                
                
                if(paginaActual.value === 0){
                    turnosDisponiblesList.value = [];
                }
                
                
                paginaActual.value = result.data.paginaActual;
                
                const dataProcesada = result.data.TurnosDisponibles
                .filter(filtrarPorRestriccion)
                .map(humanizarFechaYHoraTurno)
                
                turnosDisponiblesList.value = turnosDisponiblesList.value.length === 0 ? 
                   ordenarPorFecha(dataProcesada)  : [...turnosDisponiblesList.value, ...ordenarPorFecha(dataProcesada)];

           }catch(err){
               console.log(err);

           }finally{
               isLoadSugerencias.value = false;
           }
        }

        const filtrarPorRestriccion = (turno:any) => {
            const paciente = store.state.pacienteLogueado;
            const medicoEspecialidad = (especialidad.value as any)?.medicoEspecialidads?.find((medEsp:any) => medEsp.id === turno.idmedicoespecialidad);
            
            const obtenerRestriccion = (restriccion:any) => {
                return paciente.idcobertura === restriccion.idcobertura && (restriccion.idplancobertura === null || paciente.idplancobertura === restriccion.idplancobertura)
            }

            if(medicoEspecialidad?.restriccion === null) return true;

            if(medicoEspecialidad?.restriccion === RESTRICCIONES_ESPECIALIDADES.NO_ATENDER && medicoEspecialidad.medicoRestriccions.some(obtenerRestriccion)){
                return false;
            }

            if(medicoEspecialidad?.restriccion === RESTRICCIONES_ESPECIALIDADES.SOLO_ATENDER && !medicoEspecialidad.medicoRestriccions.some(obtenerRestriccion)){
                return false;
            }

            return true;
        }

        const humanizarFechaYHoraTurno = (registro:any) => {
            const diasDeLaSemana = ["Domingo","Lunes","Martes","Miércoles","Jueves","Viernes","Sábado"]
            return {
                ...registro,
                fecha:moment(registro.fecha).locale('es').format('ddd DD/MM/YYYY'),
                dia:diasDeLaSemana[moment(registro.fecha).weekday()],
            }
        }

        const ordenarPorFecha = (turnos:any) =>{
            const turnosList = turnos.sort((a:any,b:any) => {
                if(moment(a.fecha + ' ' + a.hora, 'DD/MM/YYYY mm:ss').isAfter(moment(b.fecha + ' ' + b.hora,'DD/MM/YYYY mm:ss'))){
                    return 1
                }
                if(moment(a.fecha + ' ' + a.hora, 'DD/MM/YYYY mm:ss').isBefore(moment(b.fecha + ' ' + b.hora,'DD/MM/YYYY mm:ss'))){
                    return -1
                }else{
                    return 0
                }
            })
            return turnosList
        }

        const enviarMail = async (turno:any) => {
            try {
                const titulo = 'NUEVA CITA ASIGNADA';
                
                const { nombre ,email } = store.state.pacienteLogueado;
                const { cliente } = store.state.configuracionPortal
                
                const fecha = moment(`${turno.fecha} ${turno.hora}`,'YYYY-MM-DD HH:mm:ss');
                const hora = moment(turno.hora,'HH:mm:ss').format('HH:mm').split(':');
                
                const medico = turno.medicoEspecialidad.medico.nombre;
                const especialidad = turno.medicoEspecialidad.servicioEspecialidad.descripcion;
                const sucursal = `${turno.medicoEspecialidad.sucursal.sucursal} - ${turno.medicoEspecialidad.sucursal.direccion}`

                let fechaIcs = fecha.format('YYYYMMDD');


                await axios.post('/send-email/send', {
                    toEmails:[email],
                    template_id:'d-50d122b4f0124e428c4f1ffdde3f20c1',
                    dynamic_template_data:{
                        logo:cliente.descripcion,
                        titulo:titulo,
                        nombre:`${nombre}`,
                        medico:`${medico}`,
                        especialidad:`${especialidad}`,
                        fecha:`${fecha.format('DD/MM/YYYY')}`,
                        hora:`${moment(turno.hora,'HH:mm:ss').format('HH:mm')}`,
                        direccion:`${sucursal}`

                    },
                    atachment:{
                        type:'ics',
                        data:`
BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//hacksw/handcal//NONSGML v1.0//EN
BEGIN:VEVENT
SUMMARY:${hora[0]}:${hora[1]} - Cita con Profesional ${medico?.medico}
LOCATION:${sucursal}
UID:20210210203529.594${turno.paciente.email}
DESCRIPTION:Horario de la cita: ${hora[0]}:${hora[1]}
DTSTART;VALUE=DATE:${fechaIcs}
DTEND;VALUE=DATE:${fechaIcs}
END:VEVENT
END:VCALENDAR`
                    }
                });
            } catch (error) {
                console.log(error);
            }
        }
        
        const obtenerTiposTurnosDisponibles = async () => {
            try {
                const { data } = await axios.get('/tipo-turnos/get-all')
                tiposTurnosDisponiblesList.value = data
            } catch (error) {
                console.log(error)
            }
        }

        const obtenerTurnosTemp = async () => {
            try {
                const idpaciente = store.state.pacienteLogueado.id;
                const { data } = await axios.get('/turnos/get-temporary/' + idpaciente)
                if(!data.length) return;

                turnoTemp.value = data[0];
                showConfirmTurnoPendiente.value = true;

            } catch (error:any) {
                console.log(error);
                toast.add({severity:'error',summary:'Atencion',detail:error.response?.data?.message || error.message || "Huvo un problema al crear la cita.",life:1500})
            }
        }

        const handleConfirmTemporal = async () => {
            try {
                const result = await awaitPago(turnoTemp.value.data?.metadata?.mercadoPagoData)
                
                if(!result){
                    toast.add({severity:'error',summary:'Atencion',detail:'El pago fue rechazado.',life:1500})
                    return;
                }

                await getCitaCreada(turnoTemp.value.globalreference);
            } catch (error:any) {
                console.log(error);
                toast.add({severity:'error',summary:'Atencion',detail:error.response?.data?.message || error.message || "Huvo un problema al crear la cita.",life:1500})
            }
        }

        const deleteTemporary = async (globalreference:number) => {
            await axios.delete('/turnos/delete-temporary/' + globalreference)
            turnoTemp.value = null;
        }


        const handleRetryPago = () => {
            window.open(linkPago.value.link, '_blank');
        }

        const handleCancelarPago = async () => {
            try {
                await deleteTemporary(linkPago.value?.globalreference || turnoTemp.value?.globalreference)
                linkPago.value = null;
                isLoadTurnosCreate.value = false;
                showConfirmTurnoPendiente.value = false;
                clearInterval(interval.value)
            } catch (error:any) {
                toast.add({severity:'error',summary:'Atencion',detail:error.response?.data?.message || error.message || 'Error al cancelar el pago.',life:1500})
            }
        }

        const getObjectProps = (obj:any, props:string[]) => {
            return props.reduce((acc:any, prop:string) => ({ ...acc, [prop]: obj[prop] }), {})
        }

        const idTipoTurnoSeleccionado = computed( () => {
            if(filtrarVideoConsulta.value) {
                return turnosVirtuales.value?.[0]
            } else {
                const sinTipo =  tiposTurnosDisponiblesList.value?.find( tipo => tipo.descripcion === 'SIN TIPO' && tipo.idcliente === null)
                if(sinTipo) {
                    return sinTipo.id
                } else {
                    return null
                }
            }
        })

        onBeforeMount(() => {
            
            obtenerEspecialidades()
            obtenerTiposTurnosDisponibles()
            obtenerTurnosTemp()

            sucursalesList.value = [{direccion:'Sucursal: Todas'}];
            sucursal.value = sucursalesList.value[0];
            medicosList.value = [{nombre:'Profesional: Todos'}];
            medico.value = medicosList.value[0];
            coberturaValida.value = store.getters.coberturaPermitida;
            coberturaParticular.value = store.getters.coberturaParticular;
            coberturaRequierePago.value = store.getters.coberturaRequierePago;
            
        })

        onUnmounted(() => {
            clearInterval(interval.value)
        })
        const isIOS = computed( () => {
            return [
                'iPad',
                'iPhone',
                'iPod'
            ].includes(navigator.platform)
            || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
        })

        const turnosVirtuales = computed( () => {
            return tiposTurnosDisponiblesList.value?.filter( tipo => tipo.virtual === filtrarVideoConsulta.value)
                ?.map(tipo => tipo.id) || []
        })

        const isPagoVisible = computed(() => {
            return linkPago.value !== null
        })

        const textTurnoPendiente = computed(() => {
            return `Tiene una cita sin abonar para el ${moment(turnoTemp.value?.fecha).format('DD/MM/YYYY')} a las ${moment(turnoTemp.value?.hora,'HH:mm:ss').format('HH:mm')}.`
        })

        return {
            filtrarVideoConsulta,
            tiposTurnosDisponiblesList,
            isIOS,
            isLoadTurnosCreate,
            isLoadSugerencias,
            avanzadosToggle,
            coberturaValida,
            fecha, 
            horaDesde, 
            horaHasta, 
            especialidadesList,
            especialidad,
            handleChangeEspecialidad, 
            medicosList, 
            medico, 
            sucursalesList, 
            sucursal, 
            DiasSeleccionados, 
            turnosDisponiblesList, 
            turnoSeleccionado, 
            consultarTurnosForm, 
            turnosVirtuales,
            handleConsultarTurnos,
            handleConfirmar, 
            idTipoTurnoSeleccionado,
            handleConfirmarSeleccion, 
            handleCancelarSeleccion,
            obtenerTurnosDisponibles,
            obtenerTiposTurnosDisponibles,
            coberturaParticular,
            isCoberturaPrivada,
            linkPago,
            isPagoVisible,
            handleRetryPago,
            handleCancelarPago,
            showConfirmTurnoPendiente,
            textTurnoPendiente,
            handleConfirmTemporal,
            showInvoiceDialog,
            invoiceDialogEmail,
            invoiceDialogFacturaId,
        }
    }
})
</script>

<style lang='scss'>
@function blueIntense($cantidad){
    @return var(--blue-+$cantidad);
}


.table-turnos-disponibles .p-datatable-wrapper .p-datatable-table .p-datatable-tbody {
    & > tr:nth-child(even){
        background:blueIntense(50);
        border-bottom:1px solid blueIntense(100);
        border-top:1px solid blueIntense(100);
        
    }
    & > tr.p-highlight{
        background:blueIntense(200);
    }
    @media screen and (max-width: 960px){
        & > tr > td{
            padding:0;
        }
    }
    
}

.nuevo-turno {
    .animate{
        animation: entrada-nuevo-turno .2s ease forwards;
    }
    .boton-dia{
        border: 1px solid #414141;
        /* width:90%;
         */
        /* border-radius:.2em; */
        display:inline-block;
        transition: background-color .2s ease;
        &.active{
            background-color:blueIntense(200);
        }
    }
}
</style>

<style lang="scss" scoped>
@keyframes spin {
    100% {
        transform: rotate(360deg);
    }
}

</style>